import type { SESSION_HISTORY_STATUS_FILTER } from "@/modules/members/gateway/memberApiGateway"

export const memberSessionHistoryKeys = {
  all: ["memberSessionHistory"] as const,
  summary: (filters: { memberId: string; year: number; month: number | null }) =>
    [...memberSessionHistoryKeys.all, "memberSessionHistorySummary", filters] as const,
  list: (filters: {
    memberId: string
    year: number
    month: number | null
    statusFilter: SESSION_HISTORY_STATUS_FILTER
  }) => [...memberSessionHistoryKeys.all, "memberSessionHistoryList", filters] as const,
}
